import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-confirmation',
  templateUrl: './modal-confirmation.component.html',
  styleUrls: ['./modal-confirmation.component.scss']
})
export class ModalConfirmationComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  onSave(){

    this.activeModal.close(true);   

  }

  onCancel(){

    this.activeModal.close(false);

  }

  ngOnInit(): void {
  }

}
